export default "__VITE_ASSET__lFSZX9KP__"